var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLineChart = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#81848F",
  d: "M1 23h23v1H0V0h1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#97C2EA",
  fillRule: "nonzero",
  d: "M19.5 12.79v-.04a1.25 1.25 0 1 1 .433.946l-2.44 1.413q.006.069.007.141a1.25 1.25 0 0 1-2.453.34l-3.118-.425a1.25 1.25 0 0 1-2.146.377l-4.285 2.143.002.065a1.25 1.25 0 1 1-.449-.96l4.464-2.231a1.25 1.25 0 0 1 2.329-.414l3.338.455a1.25 1.25 0 0 1 1.809-.357z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4569A5",
  fillRule: "nonzero",
  d: "M19.586 4.707a1.25 1.25 0 1 1 .707.707l-2.88 2.88a1.25 1.25 0 0 1-2.26 1.058l-3.216.292a1.25 1.25 0 0 1-2.018.54l-4.42 2.04.001.026a1.25 1.25 0 1 1-.42-.934l4.42-2.04V9.25a1.25 1.25 0 0 1 2.346-.602l3.217-.292a1.25 1.25 0 0 1 1.644-.77z"
}))));
export default SvgLineChart;